import { render, staticRenderFns } from "./TheLayout.vue?vue&type=template&id=7aff90e0"
import script from "./TheLayout.vue?vue&type=script&lang=js"
export * from "./TheLayout.vue?vue&type=script&lang=js"
import style0 from "./TheLayout.vue?vue&type=style&index=0&id=7aff90e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports